import Collapse from "@material-ui/core/Collapse";
import withStyles from "@material-ui/core/styles/withStyles";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { FormattedMessage, IntlProvider } from "react-intl";
import { connect } from "react-redux";
import Select from "react-select";
import { bindActionCreators } from "redux";
import {
  CommonReducerAction,
  setHelperText,
} from "../../../../../../../../Actions/commonAction";
import { ChangeLanguage } from "../../../../../../../../Actions/LanguageAction";
import CheckImg from "../../../../../../../../Assets/Images/aaa.png";
import InputValues from "../../../../../../../../Component/InputValues";
import FloatValues from "../../../../../../../../Component/FloatValues";
import { ReducersTypes } from "../../../../../../../../Constants";
import LeavePlan from "../..";

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
    backgroundColor: theme.palette.background.paper,
    marginRight: "10px",
  },
  typography: {},
});
const ParentState = {
  leaveid: null,
  maxleaveinprobation: 0,
  isrestrictinprobation: false,
  isprobationaccumulation:false,
  maxleavedurationtype: { displayname: "Month", displayvalue: 1 },
  maxleavedurationtypeid: 1,
  maxconsecutiveleavedurationtype: [],
  maxconsecutiveleavedurationtypeid: null,
  maxleave: 0,
  maxconsecutiveleave: 0,
  isallowhalfday: false,
  isfurtureappallowed: false,
  minleavecountforapp: 1,
  notifyinadvanceday: 1,
  notifynotbeforeday: 1,
  apppastday: 1,
  ispastappallowed: false,
  isleaveallowedinnotice: false,
  leavecountinnotice: null, // removed this key, bcz removed section 1
  handleLeaveCount: false,
  durationType: [
    { displayname: "Month", displayvalue: 1 },
    { displayname: "Quarter", displayvalue: 2 },
  ],
};
class LeaveUsageLimit extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...ParentState,
      ParentIndex: props.ParentIndex || 0,
      leavetypeid: props.leavetypeid,
    };
  }

  componentWillMount() {
    this.SetValues(this.props);
  }

  componentWillReceiveProps(props) {
    if (this.state.ParentIndex != props.ParentIndex) {
      this.setState({ ParentIndex: props.ParentIndex }, () => {
        this.SetValues(props);
      });
    }
    if (this.state.leavetypeid != props.leavetypeid) {
      this.setState({ leavetypeid: props.leavetypeid });
    }
  }

  SetValues(props) {
    const { ParentIndex } = props;
    if (props.InitLeavesPolicy.policy[ParentIndex]) {
      this.setState(
        {
          ParentIndex,
          leavetypeid: props.leavetypeid,
          leaveid: props.InitLeavesPolicy.policy[ParentIndex].leaveid,
          maxleaveinprobation:
            props.InitLeavesPolicy.policy[ParentIndex].maxleaveinprobation,
          isrestrictinprobation:
            props.InitLeavesPolicy.policy[ParentIndex].isrestrictinprobation,
          isprobationaccumulation:
            props.InitLeavesPolicy.policy[ParentIndex].isprobationaccumulation, 
          maxleavedurationtypeid:
            props.InitLeavesPolicy.policy[ParentIndex].maxleavedurationtypeid,
          maxleave: props.InitLeavesPolicy.policy[ParentIndex].maxleave,
          maxconsecutiveleave:
            props.InitLeavesPolicy.policy[ParentIndex].maxconsecutiveleave,
          maxconsecutiveleavedurationtypeid:
            props.InitLeavesPolicy.policy[ParentIndex]
              .maxconsecutiveleavedurationtypeid,
          isallowhalfday:
            props.InitLeavesPolicy.policy[ParentIndex].isallowhalfday,
          isfurtureappallowed:
            props.InitLeavesPolicy.policy[ParentIndex].isfurtureappallowed,
          minleavecountforapp:
            props.InitLeavesPolicy.policy[ParentIndex].minleavecountforapp,
          notifyinadvanceday:
            props.InitLeavesPolicy.policy[ParentIndex].notifyinadvanceday,
          notifynotbeforeday:
            props.InitLeavesPolicy.policy[ParentIndex].notifynotbeforeday,
          apppastday: props.InitLeavesPolicy.policy[ParentIndex].apppastday,
          ispastappallowed:
            props.InitLeavesPolicy.policy[ParentIndex].ispastappallowed,
          isleaveallowedinnotice:
            props.InitLeavesPolicy.policy[ParentIndex].isleaveallowedinnotice,
          leavecountinnotice:
            props.InitLeavesPolicy.policy[ParentIndex].leavecountinnotice,
        },
        () => {
          const { maxleavedurationtypeid } = this.state;
          const { maxconsecutiveleavedurationtypeid } = this.state;
          const filterObj = this.state.durationType.find(
            (x) => x.displayvalue == maxleavedurationtypeid,
          );
          const filterObj2 = this.state.durationType.find(
            (x) => x.displayvalue == maxconsecutiveleavedurationtypeid,
          );
          this.setState({
            maxleavedurationtype: filterObj,
            maxconsecutiveleavedurationtype: filterObj2,
          });
          if (this.state.leavecountinnotice > 0) {
            this.setState({ handleLeaveCount: true });
          }
        },
      );
    } else {
      this.setState({ ...ParentState });
    }
  }

  UpdateReducer = () => {
    const { ParentIndex } = this.state;
    const { InitLeavesPolicy } = this.props;
    if (!InitLeavesPolicy.policy[ParentIndex]) {
      const plan = LeavePlan.find(
        (x) => x.leavetypeid == this.state.leavetypeid,
      );
      InitLeavesPolicy.policy[ParentIndex] = plan.Reducer;
    }
    InitLeavesPolicy.policy[ParentIndex] = {
      ...InitLeavesPolicy.policy[ParentIndex],
      maxleaveinprobation: this.state.maxleaveinprobation,
      isrestrictinprobation: this.state.isrestrictinprobation,
      isprobationaccumulation: this.state.isprobationaccumulation,
      maxleavedurationtypeid: this.state.maxleavedurationtypeid,
      maxleave: this.state.maxleave,
      maxconsecutiveleave: this.state.maxconsecutiveleave,
      maxconsecutiveleavedurationtypeid:
        this.state.maxconsecutiveleavedurationtypeid,
      isallowhalfday: this.state.isallowhalfday,
      isfurtureappallowed: this.state.isfurtureappallowed,
      minleavecountforapp: this.state.minleavecountforapp,
      notifyinadvanceday: this.state.notifyinadvanceday,
      notifynotbeforeday: this.state.notifynotbeforeday,
      apppastday: this.state.apppastday,
      ispastappallowed: this.state.ispastappallowed,
      isleaveallowedinnotice: this.state.isleaveallowedinnotice,
      leavecountinnotice: this.state.leavecountinnotice,
    };
    this.props.CommonReducerAction(
      ReducersTypes.LEAVESPOLICY,
      InitLeavesPolicy,
    );
  };

  CommonNumberChange = (name, max, event) => {
    console.log("name, max, event: ", name, max, event);
    // const numbers = /^[0-9]+$/;
    if (event.target.value) {
      let value;
      if (
        Number(event.target.value) > Number(max) ||
        Number.isNaN(event.target.value)
      ) {
        value = this.state[name];
      } else value = Number(event.target.value);
      this.setState({ [name]: value }, () => this.UpdateReducer());
    }
  };

  handleChange(name, ...arg) {
    switch (name) {
      case "maxleavedurationtype":
      case "maxconsecutiveleavedurationtype": {
        this.setState({ [name]: arg[0] }, () => {
          this.options(name, arg);
        });
        break;
      }
      case "isallowhalfday":
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      case "isfurtureappallowed":
        this.setState(
          {
            [name]: arg[0],
            minleavecountforapp: 0,
            notifyinadvanceday: 1,
            notifynotbeforeday: 2,
          },
          () => {
            this.UpdateReducer();
          },
        );
        break;
      case "ispastappallowed":
        this.setState({ [name]: arg[0], apppastday: 0 }, () => {
          this.UpdateReducer();
        });
        break;
      case "isleaveallowedinnotice":
        this.setState(
          { [name]: arg[0], leavecountinnotice: 0, handleLeaveCount: false },
          () => {
            this.UpdateReducer();
          },
        );
        break;
      case "handleLeaveCount":
        this.setState({ [name]: arg[0], leavecountinnotice: 0 }, () => {
          if (this.state.handleLeaveCount) {
            this.setState({ leavecountinnotice: 1 });
          }
          this.UpdateReducer();
        });
        break;
      case "isrestrictinprobation":
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      case "isprobationaccumulation":
        this.setState({ [name]: arg[0] }, () => this.UpdateReducer());
        break;
      default:
        break;
    }
  }

  options(name, selected) {
    const arg = selected[0];
    switch (name) {
      case "maxleavedurationtype":
        this.setState({ maxleavedurationtypeid: arg.displayvalue }, () => {
          this.UpdateReducer();
        });
        break;
      case "maxconsecutiveleavedurationtype":
        this.setState(
          { maxconsecutiveleavedurationtypeid: arg.displayvalue },
          () => this.UpdateReducer(),
        );
        break;
      default:
        break;
    }
  }

  render() {
    const language = this.props.Language.leaveusagelimit;
    const isMonthSelected =
      this.state.maxleavedurationtypeid &&
      this.state.maxleavedurationtypeid == 1;
    return (
      <IntlProvider locale="en" messages={language}>
        <div className="margin-top-20">
          <p className="form-sub-header">
            <FormattedMessage
              id="__LbLeaveUsageLimits"
              defaultMessage="Lets configure the leave usage limits"
            />
          </p>
          {/* 1 */}
          <div className="inner-wrapper opaque margin-top-10">
            <div>
              <p className="depedent-select-list-head margin-bottom-0">
                <FormattedMessage
                  id="LbDuringProbation"
                  defaultMessage="During Probation"
                />
              </p>
              <FormattedMessage
                id="LbAllowOnlyMax"
                defaultMessage="Allow only a maximum of"
              />
              <FloatValues
                min="0"
                max="28"
                step="0.5"
                field="maxleaveinprobation"
                defaultvalue={this.state.maxleaveinprobation}
                onChange={this.CommonNumberChange.bind(
                  this,
                  "maxleaveinprobation",
                  28,
                )}
                value={this.state.maxleaveinprobation}
              />

              <FormattedMessage
                id="LbDaysLeaveInProbation"
                defaultMessage="days leave in a probation month"
              />
              <br />
            </div>

            <div className="inner-wrapper opaque margin-top-20 margin-bottom-20">
              <p className="depedent-select-list-head">
                <FormattedMessage
                  id="LbAllowHalfDayApplication"
                  defaultMessage="Allow accumulation of balance in probation period"
                />
              </p>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("isprobationaccumulation", true)}
                aria-expanded={this.state.isprobationaccumulation == true}
              >
                <span>
                  <FormattedMessage id="LbYes" defaultMessage="Yes" />
                </span>
                {this.state.isprobationaccumulation == true ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected " />
                )}
              </div>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("isprobationaccumulation", false)}
                aria-expanded={this.state.isprobationaccumulation == false}
              >
                <span>
                  <FormattedMessage id="LbNo" defaultMessage="No" />
                </span>
                {this.state.isprobationaccumulation == false ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected" />
                )}
              </div>
            </div>

            <div className="inner-wrapper opaque margin-top-20 margin-bottom-20">
              <p className="depedent-select-list-head">
                <FormattedMessage
                  id="LbAllowHalfDayApplication"
                  defaultMessage="Do you want to allow employees to apply this leave during probation?"
                />
              </p>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("isrestrictinprobation", false)}
                aria-expanded={this.state.isrestrictinprobation == false}
              >
                <span>
                  <FormattedMessage id="LbYes" defaultMessage="Yes" />
                </span>
                {this.state.isrestrictinprobation == false ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected " />
                )}
              </div>
              <div
                className="depedent-select-list"
                onClick={() => this.handleChange("isrestrictinprobation", true)}
                aria-expanded={this.state.isrestrictinprobation == true}
              >
                <span>
                  <FormattedMessage id="LbNo" defaultMessage="No" />
                </span>
                {this.state.isrestrictinprobation == true ? (
                  <span className="floatright">
                    <img src={CheckImg} height="20" />
                  </span>
                ) : (
                  <span className="not-selected" />
                )}
              </div>
            </div>


            <div>
              <p className="depedent-select-list-head margin-bottom-8 margin-top-10">
                <FormattedMessage
                  id="LbAfterConfirmation"
                  defaultMessage="After Confirmation"
                />
              </p>
              <div>
                <span className="floatleft margin-right-10 margin-top-16">
                  In a{" "}
                </span>
                <span className="floatleft width25 margin-top-8 margin-right-8">
                  <Select
                    autofocus
                    placeholder="Select"
                    options={this.state.durationType}
                    getOptionLabel={(option) => option.displayname}
                    getOptionValue={(option) => option.displayvalue}
                    onChange={this.handleChange.bind(
                      this,
                      "maxleavedurationtype",
                    )}
                    value={this.state.maxleavedurationtype}
                    className=""
                  />
                </span>
                <span>
                  <FormattedMessage
                    id="__LbAllowOnlyMax"
                    defaultMessage="allow only a maximum of"
                  />
                  <FloatValues
                    min="0"
                    max={isMonthSelected ? "28" : "90"}
                    field="maxleave"
                    onChange={this.CommonNumberChange.bind(
                      this,
                      "maxleave",
                      isMonthSelected ? "28" : "90",
                    )}
                    step="0.5"
                    value={this.state.maxleave}
                    defaultvalue={this.state.maxleave}
                  />
                  <FormattedMessage
                    id="__LbDaysInAmonthorquarter"
                    defaultMessage="days leaves "
                  />
                </span>
              </div>
              <br />
            </div>
          </div>
          {/** new 2nd */}
          <div className="inner-wrapper opaque margin-top-20">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="__LbAllowOnlyMaxConsecutive"
                defaultMessage="How many maximum consecutive leaves you want to allow?"
              />
            </p>
            <InputValues
              min="0"
              max="365"
              field="maxconsecutiveleave"
              onChange={this.CommonNumberChange.bind(
                this,
                "maxconsecutiveleave",
                365,
              )}
              value={this.state.maxconsecutiveleave}
              defaultvalue={this.state.maxconsecutiveleave}
            />
            <FormattedMessage id="LbDays" defaultMessage="days" />
          </div>
          {/* 2 */}
          <div className="inner-wrapper opaque margin-top-20">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbAllowHalfDayApplication"
                defaultMessage="Would you like to allow half-day leave applications?"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isallowhalfday", true)}
              aria-expanded={this.state.isallowhalfday == true}
            >
              <span>
                <FormattedMessage id="LbYes" defaultMessage="Yes" />
              </span>
              {this.state.isallowhalfday == true ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isallowhalfday", false)}
              aria-expanded={this.state.isallowhalfday == false}
            >
              <span>
                <FormattedMessage id="LbNo" defaultMessage="No" />
              </span>
              {this.state.isallowhalfday == false ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected" />
              )}
            </div>
          </div>
          {/* 3 */}
          <div className="inner-wrapper opaque margin-top-20">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbLimitFutureApplications"
                defaultMessage="Do you want to limit leave applications for future dates?"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isfurtureappallowed", true)}
              aria-expanded={this.state.isfurtureappallowed == true}
            >
              <span>
                {" "}
                <FormattedMessage id="LbYes" defaultMessage="Yes" />{" "}
              </span>
              {this.state.isfurtureappallowed == true ? (
                <span className="floatright">
                  {" "}
                  <img src={CheckImg} height="20" />{" "}
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            <div className="et-level2">
              <Collapse
                in={this.state.isfurtureappallowed}
                timeout={2}
                unmountOnExit
                className="padding30 overflow-initial"
              >
                {/* <FormattedMessage id="LbLeaveDurationGreater" defaultMessage="If leave duration is greater than" /> */}
                If leave duration is more than
                <InputValues
                  min="0"
                  max="365"
                  field="minleavecountforapp"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "minleavecountforapp",
                    365,
                  )}
                  value={this.state.minleavecountforapp}
                  defaultvalue={this.state.minleavecountforapp}
                />
                <span>days, </span>
                <br />
                <FormattedMessage
                  id="__LbApplicationMustBe"
                  defaultMessage="employee must apply for a leave  atleast"
                />
                <InputValues
                  min="1"
                  max="365"
                  field="notifyinadvanceday"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "notifyinadvanceday",
                    365,
                  )}
                  value={this.state.notifyinadvanceday}
                  defaultvalue={this.state.notifyinadvanceday}
                />
                <span>days in advance,</span>
                <br />
                <FormattedMessage
                  id="__LbButNotEarlier1"
                  defaultMessage="but not earlier than"
                />
                {/* <FormattedMessage id="__LbApplicationMustBe" defaultMessage="days, employee must apply for a leave  atleast" /><br />
                                <InputValues
                                    min="1"
                                    max="365"
                                    field="notifyinadvanceday"
                                    onChange={this.CommonNumberChange.bind(this, "notifyinadvanceday", 365)}
                                    value={this.state.notifyinadvanceday}
                                    defaultvalue={this.state.notifyinadvanceday}
                                />
                                days in advance, but not earlier than */}
                <InputValues
                  min={
                    (this.state.notifyinadvanceday &&
                      parseInt(this.state.notifyinadvanceday) + 1) ||
                    2
                  }
                  //   min={this.state.notifyinadvanceday && this.state.notifyinadvanceday}
                  max="365"
                  field="notifynotbeforeday"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "notifynotbeforeday",
                    365,
                  )}
                  value={this.state.notifynotbeforeday}
                  defaultvalue={this.state.notifynotbeforeday || 2}
                />
                <FormattedMessage id="LbDays" defaultMessage="days" />
              </Collapse>
            </div>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isfurtureappallowed", false)}
              aria-expanded={this.state.isfurtureappallowed == false}
            >
              <span>
                <FormattedMessage id="LbNo" defaultMessage="No" />
              </span>
              {this.state.isfurtureappallowed == false ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected" />
              )}
            </div>
          </div>
          {/* 4 */}
          <div className="inner-wrapper opaque margin-top-20">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbPastApplications"
                defaultMessage="Do you want to allow leave application for past dates?"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("ispastappallowed", true)}
              aria-expanded={this.state.ispastappallowed == true}
            >
              <span>
                <FormattedMessage id="LbYes" defaultMessage="Yes" />
              </span>
              {this.state.ispastappallowed == true ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            <div className="et-level2">
              <Collapse
                in={this.state.ispastappallowed}
                timeout={2}
                unmountOnExit
                className="padding30 overflow-initial"
              >
                <FormattedMessage
                  id="LbApplMadeUpTo"
                  defaultMessage="Leave application can be made upto"
                />
                <InputValues
                  min="1"
                  max="90"
                  field="apppastday"
                  onChange={this.CommonNumberChange.bind(
                    this,
                    "apppastday",
                    90,
                  )}
                  value={this.state.apppastday}
                  defaultvalue={this.state.apppastday}
                />

                <FormattedMessage
                  id="LbActualLeaveDate"
                  defaultMessage="days after actual leave date"
                />
              </Collapse>
            </div>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("ispastappallowed", false)}
              aria-expanded={this.state.ispastappallowed == false}
            >
              <span>
                <FormattedMessage id="LbNo" defaultMessage="No" />
              </span>
              {this.state.ispastappallowed == false ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected" />
              )}
            </div>
          </div>
          {/* 5 */}
          <div className="inner-wrapper opaque margin-top-20">
            <p className="depedent-select-list-head">
              <FormattedMessage
                id="LbLeaveDuringNotice"
                defaultMessage="Do you want to allow the use of leaves during notice period?"
              />
            </p>
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isleaveallowedinnotice", true)}
              aria-expanded={this.state.isleaveallowedinnotice == true}
            >
              <span>
                <FormattedMessage id="LbYes" defaultMessage="Yes" />
              </span>
              {this.state.isleaveallowedinnotice == true ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected " />
              )}
            </div>
            {/* <div className="et-level2">
              <Collapse
                in={this.state.isleaveallowedinnotice}
                timeout={2}
                unmountOnExit
                className="padding30 overflow-initial"
              >
                <p class="depedent-select-list-head">
                  <FormattedMessage
                    id="LbLeaveCount"
                    defaultMessage="How many leaves are allowed during notice period?"
                  />
                </p>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("handleLeaveCount", true)}
                  aria-expanded={this.state.handleLeaveCount == true ? true : false}
                >
                  <span>
                    <FormattedMessage id="LbYes" defaultMessage="Yes" />
                  </span>
                  {this.state.handleLeaveCount == true ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected " />
                  )}
                </div>
                <div className="et-level3">
                  <Collapse
                    in={this.state.handleLeaveCount}
                    timeout={2}
                    unmountOnExit
                    className="padding30 overflow-initial"
                  >
                    <FormattedMessage id="LbAllowOnly" defaultMessage="Allow only" />
                    <InputValues
                      min="1"
                      max="30"
                      field="leavecountinnotice"
                      onChange={this.CommonNumberChange.bind(this, "leavecountinnotice", 30)}
                      value={this.state.leavecountinnotice}
                      defaultvalue={this.state.leavecountinnotice}
                    />
                    <FormattedMessage id="LbLeaves" defaultMessage="leaves" />
                  </Collapse>
                </div>
                <div
                  className="depedent-select-list"
                  onClick={() => this.handleChange("handleLeaveCount", false)}
                  aria-expanded={this.state.handleLeaveCount == false ? true : false}
                >
                  <span>
                    <FormattedMessage id="LbNo" defaultMessage="No" />
                  </span>
                  {this.state.handleLeaveCount == false ? (
                    <span className="floatright">
                      <img src={CheckImg} height="20" />
                    </span>
                  ) : (
                    <span className="not-selected" />
                  )}
                </div>
              </Collapse>
            </div>
             */}
            <div
              className="depedent-select-list"
              onClick={() => this.handleChange("isleaveallowedinnotice", false)}
              aria-expanded={this.state.isleaveallowedinnotice == false}
            >
              <span>
                <FormattedMessage id="LbNo" defaultMessage="No" />
              </span>
              {this.state.isleaveallowedinnotice == false ? (
                <span className="floatright">
                  <img src={CheckImg} height="20" />
                </span>
              ) : (
                <span className="not-selected" />
              )}
            </div>
          </div>
        </div>
      </IntlProvider>
    );
  }
}
LeaveUsageLimit.propTypes = {
  classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => ({
  Language: state.LanguageAction.Language,
  InitLeavesPolicy: state.InitLeavesPolicy,
});
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      ChangeLanguage: (data) => ChangeLanguage(data),
      CommonReducerAction: (type, data) => CommonReducerAction(type, data),
      setHelperText: (data) => setHelperText(data),
    },
    dispatch,
  );
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(LeaveUsageLimit)));
